import options from './screenshot.directive';

export default {
    selector: 'dtScreenshot',
    options
};



// WEBPACK FOOTER //
// ./app/common/screenshot/index.js